import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1569322956/src/repo/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/codebuild/output/src1569322956/src/repo/layouts/guest.vue").then(m => m.default || m)),
  showcase: defineAsyncComponent(() => import("/codebuild/output/src1569322956/src/repo/layouts/showcase.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/codebuild/output/src1569322956/src/repo/layouts/simple.vue").then(m => m.default || m))
}